import React from 'react';
import * as Cesium from 'cesium';
import cesiumPackage from 'cesium/package.json';
import 'cesium/Build/Cesium/Widgets/widgets.css';
import Button from '@material-ui/core/Button';
import MaterialIcon from '../../../components/MaterialIcon';
import loadBaseReplay3DApp from './baseReplay3DApp';
import BaseReplay3DLayout from './baseReplay3DLayout';
import emb200Model from '../../../assets/replay_3d/models/emb-200/aeronave.glb';
import airTractorAt502bModel from '../../../assets/replay_3d/models/air-tractor-at-502b/aeronave.glb';
import airTractorAt802Model from '../../../assets/replay_3d/models/air-tractor-at-802/aeronave.glb';
import cessna188Model from '../../../assets/replay_3d/models/cessna-188/aeronave.glb';
import emb203Model from '../../../assets/replay_3d/models/emb-203/aeronave.glb';
import thrush510Model from '../../../assets/replay_3d/models/thrush-510/aeronave.glb';
import './replay3D.css';

const cesiumIonToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJmMjFlMzc4ZC1hMjkzLTRhYTQtYTcxZi01Y2EzMTM0NTczYmUiLCJpZCI6MzIwMzMwLCJpYXQiOjE3NTIxNTc3OTV9.3Hevk1CLhRrpuR2DSjyD2pGdzwmmsKMn0PApg0FoxNc';
const cesiumBaseUrl = 'https://cdn.jsdelivr.net/npm/cesium@' + cesiumPackage.version + '/Build/Cesium/';
const replay3DLoadingTimeMs = 20000;
const aircraftModels = [
  {
    id: 'air-tractor-at-502b',
    label: 'Air Tractor AT-502B',
    url: airTractorAt502bModel,
    scale: 0.05,
    modelHeadingOffsetDeg: 0,
    modelPitchOffsetDeg: -8,
    modelRollOffsetDeg: 0,
    minimumPixelSize: 18,
    modelAltitudeOffsetMeters: 13,
    sprayMistVerticalOffsetMeters: -8.5,
    propellerGroups: [
      {
        id: 'helice_aviao',
        nodes: ['objpropeller_basic_airtractor'],
        axis: 'z',
        rpm: 900,
        spinSign: -1,
        pivot: [-0.5831, 87.3068, 531.6978]
      },
      {
        id: 'bomba_eolica',
        nodes: ['objpropeller_small_airtractor'],
        axis: 'z',
        rpm: 1400,
        spinSign: -1,
        pivot: [-0.1409, -59.7121, 262.3489]
      }
    ]
  },
  {
    id: 'air-tractor-at-802',
    label: 'Air Tractor AT-802',
    url: airTractorAt802Model,
    scale: 0.125,
    modelHeadingOffsetDeg: 0,
    modelPitchOffsetDeg: -8,
    modelRollOffsetDeg: 0,
    minimumPixelSize: 18,
    modelAltitudeOffsetMeters: 13,
    sprayMistVerticalOffsetMeters: -8.5,
    propellerGroups: [
      {
        id: 'helice_aviao',
        nodes: ['objpropeller_basic'],
        axis: 'z',
        rpm: 900,
        spinSign: -1,
        pivot: [-0.25, 40.8, 249.05]
      },
      {
        id: 'bomba_eolica',
        nodes: ['objpropeller_small'],
        axis: 'z',
        rpm: 1400,
        spinSign: -1,
        pivot: [-0.06608963012694957, -28.006233215331928, 123.04706573486402]
      }
    ]
  },
  {
    id: 'cessna-188',
    label: 'Cessna 188 AG',
    url: cessna188Model,
    scale: 1.5,
    modelHeadingOffsetDeg: 180,
    modelPitchOffsetDeg: -8,
    modelRollOffsetDeg: 0,
    minimumPixelSize: 18,
    modelAltitudeOffsetMeters: 5,
    sprayMistVerticalOffsetMeters: 0.3,
    propellerGroups: [
      {
        id: 'helice_aviao',
        nodes: [
          'cessna_188_ag_ipanema_propeller_Cylinder32_pivot',
          'cessna_188_ag_ipanema_propeller_Cylinder104_pivot',
          'cessna_188_ag_ipanema_propeller_Cylinder108_pivot',
          'cessna_188_ag_ipanema_propeller_Cylinder01',
          'cessna_188_ag_ipanema_propeller_Cylinder31',
          'cessna_188_ag_ipanema_propeller_Cylinder301',
          'cessna_188_ag_ipanema_propeller_Cylinder102_pivot',
          'cessna_188_ag_ipanema_propeller_Cylinder106_pivot',
          'cessna_188_ag_ipanema_propeller_Cylinder110_pivot'
        ],
        axis: 'z',
        rpm: 900,
        spinSign: -1,
        pivot: [0.002090245485305786, 7.712601900100708, -17.66800308227539]
      }
    ]
  },
  {
    id: 'emb200',
    label: 'EMB-200 Ipanema',
    url: emb200Model,
    scale: 0.2,
    modelHeadingOffsetDeg: 0,
    modelPitchOffsetDeg: 90,
    modelRollOffsetDeg: 0,
    minimumPixelSize: 18,
    modelAltitudeOffsetMeters: 5,
    sprayMistVerticalOffsetMeters: 0.3
  },
  {
    id: 'emb-203',
    label: 'EMB-203 Ipanema',
    url: emb203Model,
    scale: 50,
    modelHeadingOffsetDeg: -90,
    modelPitchOffsetDeg: 0,
    modelRollOffsetDeg: 0,
    minimumPixelSize: 18,
    modelAltitudeOffsetMeters: 10,
    sprayMistVerticalOffsetMeters: -7,
    propellerGroups: [
      {
        id: 'helice_aviao',
        nodes: [
          'emb203_helice_Cylinder32_pivot',
          'emb203_helice_Cylinder104_pivot',
          'emb203_helice_Cylinder108_pivot',
          'emb203_helice_Cylinder01',
          'emb203_helice_Cylinder31',
          'emb203_helice_Cylinder301',
          'emb203_helice_Cylinder102_pivot',
          'emb203_helice_Cylinder106_pivot',
          'emb203_helice_Cylinder110_pivot'
        ],
        axis: 'x',
        rpm: 780,
        spinSign: -1,
        pivot: [-0.653, 0.09, 0]
      },
      {
        id: 'bomba_eolica',
        nodes: [
          'emb203_bomba_eolica_Cylinder136',
          'emb203_bomba_eolica_Cylinder144',
          'emb203_bomba_eolica_Turbine_2_Spinner',
          'emb203_bomba_eolica_Cylinder145',
          'emb203_bomba_eolica_Cylinder146',
          'emb203_bomba_eolica_Cylinder147',
          'emb203_bomba_eolica_Cylinder148',
          'emb203_bomba_eolica_Cylinder149',
          'emb203_bomba_eolica_Cylinder150',
          'emb203_bomba_eolica_Cylinder151'
        ],
        axis: 'x',
        rpm: 1200,
        spinSign: -1,
        pivot: [-0.1835, -0.1155, -0.1005]
      }
    ]
  },
  {
    id: 'thrush-510',
    label: 'Thrush 510',
    url: thrush510Model,
    scale: 40,
    modelHeadingOffsetDeg: -90,
    modelPitchOffsetDeg: 0,
    modelRollOffsetDeg: 0,
    minimumPixelSize: 18,
    modelAltitudeOffsetMeters: 5,
    sprayMistVerticalOffsetMeters: -7.5,
    sprayMistBackOffsetMeters: 1.5,
    propellerGroups: [
      {
        id: 'helice_aviao',
        nodes: ['thrush510_helice_objpropeller_basic_airtractor'],
        axis: 'x',
        rpm: 780,
        spinSign: -1,
        pivot: [-0.736658, -0.049432, -0.000088],
        translationOffset: [0.105, 0, 0]
      },
      {
        id: 'bomba_eolica',
        nodes: ['thrush510_bomba_eolica_objpropeller_small_airtractor'],
        axis: 'x',
        rpm: 1200,
        spinSign: -1,
        pivot: [-0.447026, -0.206878, 0.000396]
      }
    ]
  }
];
class Replay3D extends React.Component {
  state = { fullscreen: false, loading: true };
  mounted = false;
  loaded = false;
  loadingTimer = null;

  componentDidMount() {
    this.mounted = true;
    this.configureCesiumRuntime();
    window.__travicarReplay3DTexts = this.props.res;
    window.__travicarReplay3DAircraftModels = this.getRuntimeAircraftModels();
    this.applyReplay3DDefaultAircraftGlobals();
    window.__travicarReplay3DInitialTilesReady = this.hideLoading;
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    this.loadingTimer = setTimeout(this.hideLoading, replay3DLoadingTimeMs);
    this.loadBaseRuntime();
  }

  componentDidUpdate(prevProps) {
    this.configureCesiumRuntime();
    window.__travicarReplay3DTexts = this.props.res;
    window.__travicarReplay3DAircraftModels = this.getRuntimeAircraftModels();
    this.applyReplay3DDefaultAircraftGlobals();

    if (
      prevProps.data !== this.props.data ||
      prevProps.polygons !== this.props.polygons ||
      prevProps.p !== this.props.p ||
      prevProps.modelUrl !== this.props.modelUrl ||
      prevProps.defaultModelType !== this.props.defaultModelType ||
      prevProps.selectedAircraftBrand !== this.props.selectedAircraftBrand ||
      prevProps.selectedAircraft !== this.props.selectedAircraft
    ) {
      this.loadOfficialData();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
    }
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    if (window.__travicarReplay3DInitialTilesReady === this.hideLoading) {
      window.__travicarReplay3DInitialTilesReady = null;
    }
    if (window.__travicarReplay3DDestroy) {
      window.__travicarReplay3DDestroy();
    }
    window.__travicarReplay3DDefaultAircraftId = null;
    window.__travicarReplay3DDefaultModelType = null;
  }

  configureCesiumRuntime = () => {
    window.CESIUM_BASE_URL = cesiumBaseUrl;
    window.Cesium = Cesium;
    Cesium.Ion.defaultAccessToken = cesiumIonToken;
  };

  normalizeReplay3DText = (value) => {
    if (value === null || value === undefined) return '';

    let text = String(value).toLowerCase();

    if (text.normalize) {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return text;
  };


  normalizeReplay3DModelId = (value) => {
    const model = String(value || '').trim();

    return aircraftModels.some(item => item.id === model) ? model : '';
  };

  getSelectedAircraftModel3D = () => {
    const selectedAircraft = this.props.selectedAircraft || {};

    return this.normalizeReplay3DModelId(selectedAircraft.model3D);
  };

  getRuntimeAircraftModels = () => {
    return aircraftModels.map((model) => {
      const item = Object.assign({}, model);

      if (model && model.propellerGroups) {
        item.propellerGroups = model.propellerGroups;
      }

      return item;
    });
  };

  getDefaultAircraftId = () => {
    const selectedAircraft = this.props.selectedAircraft || {};
    const selectedModel3D = this.getSelectedAircraftModel3D();

    if (selectedModel3D) return selectedModel3D;

    const brand = String(selectedAircraft.aircraftbrand || '').trim();
    const model = String(selectedAircraft.aircraftmodel || '').trim();

    if (brand === 'Thrush') return 'thrush-510';
    if (brand === 'Embraer' && model === 'EMB-203') return 'emb-203';
    if (brand === 'Cessna') return 'cessna-188';
    if (brand === 'Air Tractor') {
      return model === 'AT-802' || model === 'AT-802A'
        ? 'air-tractor-at-802'
        : 'air-tractor-at-502b';
    }

    return 'emb200';
  };

  getDefaultModelType = () => {
    const aircraftId = this.getDefaultAircraftId();

    if (aircraftId === 'air-tractor-at-502b' || aircraftId === 'air-tractor-at-802') return 'airtractor';
    if (aircraftId === 'cessna-188') return 'cessna';
    return aircraftId;
  };

  getDefaultAircraftModel = () => {
    const defaultAircraftId = this.getDefaultAircraftId();

    for (let i = 0; i < aircraftModels.length; i++) {
      if (aircraftModels[i] && aircraftModels[i].id === defaultAircraftId) {
        return aircraftModels[i];
      }
    }

    return aircraftModels[0] || null;
  };

  getDefaultModelUrl = () => {
    const defaultModel = this.getDefaultAircraftModel();

    if (defaultModel && defaultModel.url) {
      return defaultModel.url;
    }

    return typeof this.props.modelUrl === 'string' ? this.props.modelUrl : '';
  };

  applyReplay3DDefaultAircraftGlobals = () => {
    window.__travicarReplay3DDefaultAircraftId = this.getDefaultAircraftId();
    window.__travicarReplay3DDefaultModelType = this.getDefaultModelType();
  };

  hideLoading = () => {
    if (!this.mounted) return;

    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
    }

    if (this.state && this.state.loading) {
      this.setState({ loading: false });
    }
  };

  loadBaseRuntime = () => {
    if (!this.mounted || this.loaded) return;

    loadBaseReplay3DApp();

    this.loaded = true;
    setTimeout(() => this.loadOfficialData(), 300);
  };

  loadOfficialData = () => {
    const appRoot = document.getElementById('replay3dBaseApp');
    if (appRoot) appRoot.classList.remove('panel-collapsed');
    if (!this.loaded || !window.__travicarReplay3DLoadOfficialData) return;
    this.applyReplay3DDefaultAircraftGlobals();

    const defaultModelUrl = this.getDefaultModelUrl();
    const defaultAircraftId = this.getDefaultAircraftId();

    window.__travicarReplay3DLoadOfficialData(
      this.props.data,
      this.props.polygons,
      this.props.p,
      defaultModelUrl,
      this.props.qualityConfig,
      defaultAircraftId
    );
  };

  handleFullscreenChange = () => {
    this.setState({ fullscreen: !!document.fullscreenElement });
  };

  toggleFullscreen = () => {
    const element = document.querySelector('.replay3d-base-overlay');

    if (!element) return;

    if (document.fullscreenElement) {
      document.exitFullscreen();
      this.setState({ fullscreen: false });
      return;
    }

    if (element.requestFullscreen) {
      element.requestFullscreen();
      this.setState({ fullscreen: true });
    }
  };

  render() {
    const fullscreen = this.state && this.state.fullscreen;
    const loading = this.state && this.state.loading;
    const fullscreenIcon = fullscreen ? 'fullscreen_exit' : 'fullscreen';
    const res = this.props.res;
    const fullscreenTitle = fullscreen ? res.SAIR_TELA_CHEIA : res.TELA_CHEIA;

    return (
      <div className="replay3d-base-overlay">
        <div className="replay3d-base-app-host">
          <BaseReplay3DLayout res={res} />
        </div>
        {loading && (
          <div className="replay3d-base-loading">
            <div className="replay3d-base-loading-card">
              <div className="replay3d-base-loading-spinner" />
              <div className="replay3d-base-loading-title">{res.CARREGANDO_REPLAY_3D}</div>
              <div className="replay3d-base-loading-text">{res.PREPARANDO_MAPA_AERONAVE_DADOS_VOO}</div>
            </div>
          </div>
        )}
        <div className="replay3d-base-action-buttons">
          <Button className="replay3d-base-action-button replay3d-base-fullscreen-button" onClick={this.toggleFullscreen} title={fullscreenTitle}>
            <MaterialIcon icon={fullscreenIcon} className="iconMap" />
          </Button>
          <Button className="replay3d-base-action-button replay3d-base-close-button" onClick={this.props.onClose} title={res.FECHAR_REPLAY_3D}>
            <MaterialIcon icon="close" className="iconMap" />
          </Button>
        </div>
      </div>
    );
  }
}

export default Replay3D;
